<template>
  <div>
    <div v-loading="tree_config.loading">
      <div class="permission-toolbar">
        <el-button size="mini" type="primary" plain @click="expandAll">展开全部</el-button>
        <span class="expand-tip">展开后可以使用 Ctrl + F 搜索对应的权限</span>
      </div>
      <!-- 权限数据限制最大高度、内部滚动，保证底部按钮始终可见 -->
      <div class="permission-body">
        <p class="font-16 font-bold">菜单权限：</p>
        <el-tree
          ref="menuTree"
          class="tree"
          :data="tree_config.menu_config.options"
          node-key="id"
          show-checkbox
          :default-expanded-keys="tree_config.menu_config.expanded_keys"
          :props="tree_config.props"
        />
        <p class="font-16 font-bold">功能权限：</p>
        <el-tree
          ref="apiTree"
          class="tree"
          :data="tree_config.api_config.options"
          node-key="id"
          show-checkbox
          :default-expanded-keys="tree_config.api_config.expanded_keys"
          :props="tree_config.props"
        />
      </div>
    </div>
    <div class="text-right">
      <el-button size="mini" @click="cancel">取 消</el-button>
      <el-button size="mini" type="primary" @click="confirm">确 定</el-button>
    </div>
  </div>
</template>

<script>
import RolesResource from '@/api/roles';
const rolesResource = new RolesResource();
import PermissionsResource from '@/api/permissions';
const permissionsResource = new PermissionsResource();

export default {
  props: {
    data: { type: Object, default: null },
  },
  data() {
    return {
      tree_config: {
        loading: false,
        props: {
          children: 'children',
          label: 'name',
        },
        menu_config: {
          options: [],
          expanded_keys: [],
        },
        api_config: {
          options: [],
          expanded_keys: [],
        },
      },
      // 角色已分配的权限 - 列表接口已不再返回权限参数，改为请求「获取角色权限」接口
      role_permissions: {
        menu: [],
        api: [],
      },
    };
  },
  computed: {
    /** 获取菜单权限非父节点的节点 */
    getMenuChildNode() {
      return this.filterLeafNodes(this.role_permissions.menu);
    },
    /** 获取功能权限非父节点的节点 */
    getApiChildNode() {
      return this.filterLeafNodes(this.role_permissions.api);
    },
  },
  created() {
    this.getPermissionList();
  },
  methods: {
    /** 权限列表接口兼容数组与 { list } 两种返回结构 */
    toPermissionList(value) {
      if (Array.isArray(value)) {
        return value;
      }
      return Array.isArray(value && value.list) ? value.list : [];
    },
    /** 过滤出非父节点的权限 */
    filterLeafNodes(list) {
      const nodes = Array.isArray(list) ? list : [];
      return nodes.filter(m => !(nodes.find(e => m.id === e.parent_id)));
    },
    /** 获取全量权限树 + 该角色已分配的权限，用于回显勾选状态 */
    async getPermissionList() {
      this.tree_config.loading = true;
      try {
        const [permission_response, role_permission] = await Promise.all([
          permissionsResource.getApi(),
          rolesResource.getRolePermissionsApi(this.data.id),
        ]);
        const { menu_config, api_config } = this.tree_config;
        Object.assign(menu_config, { options: this.toPermissionList(permission_response && permission_response.menu) });
        Object.assign(api_config, { options: this.toPermissionList(permission_response && permission_response.api) });
        Object.assign(this.role_permissions, {
          menu: this.toPermissionList(role_permission && role_permission.menu),
          api: this.toPermissionList(role_permission && role_permission.api),
        });
        await this.$nextTick();
        this.$refs.menuTree.setCheckedNodes(this.getMenuChildNode);
        this.$refs.apiTree.setCheckedNodes(this.getApiChildNode);
      } catch (error) {
        console.log(error);
      } finally {
        this.tree_config.loading = false;
      }
    },
    expandAll() {
      const expand = (config) => {
        const keys = [];
        const walk = nodes => {
          nodes.forEach(node => {
            keys.push(node.id);
            if (node.children && node.children.length) {
              walk(node.children);
            }
          });
        };
        walk(config.options);
        config.expanded_keys = keys;
      };
      expand(this.tree_config.menu_config);
      expand(this.tree_config.api_config);
      this.$nextTick(() => {
        [this.$refs.menuTree, this.$refs.apiTree].forEach(tree => {
          if (!tree || !tree.store) {
            return;
          }
          tree.store.defaultExpandedKeys = tree === this.$refs.menuTree
            ? this.tree_config.menu_config.expanded_keys
            : this.tree_config.api_config.expanded_keys;
          tree.store.defaultExpandedKeys.forEach(key => {
            const node = tree.store.getNode(key);
            if (node) {
              node.expand(null, true);
            }
          });
        });
      });
    },
    confirm() {
      this.tree_config.loading = true;
      const menu_checked = this.$refs.menuTree.getCheckedNodes(false, true).map(({ id }) => id);
      const api_checked = this.$refs.apiTree.getCheckedNodes(false, true).map(({ id }) => id);
      rolesResource.editApi({ permissions: [...menu_checked, ...api_checked] }, this.data.id).then(() => {
        this.$message.success('更新成功！');
        this.tree_config.loading = false;
        this.$emit('comfirm');
      });
    },
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<style scoped>
.permission-toolbar {
  margin-bottom: 8px;
}
.expand-tip {
  margin-left: 8px;
  color: #F56C6C;
  font-size: 12px;
}
/* 与「分配游戏权限」弹窗的滚动区高度保持一致 */
.permission-body {
  max-height: 400px;
  overflow-y: auto;
}
</style>
